import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="public--accordion"
export default class extends Controller {
  toggle(event) {
    const trigger = event.currentTarget
    const item = trigger.closest(".accordion-item")
    const content = item.querySelector(".accordion-content")
    const chevron = item.querySelector(".accordion-chevron")
    const isOpen = trigger.getAttribute("aria-expanded") === "true"

    if (isOpen) {
      trigger.setAttribute("aria-expanded", "false")
      content?.classList.add("hidden")
      chevron?.classList.remove("rotate-180")
    } else {
      trigger.setAttribute("aria-expanded", "true")
      content?.classList.remove("hidden")
      chevron?.classList.add("rotate-180")
    }
  }
}
